import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  padding: 0 20px 200px 20px;

  .box-top {
    margin: 0 -20px;
    ${mixin.flex({ direction: 'column', align: 'flex-start' })};
    overflow: auto hidden;
    overscroll-behavior: contain auto;

    .main-banner {
      height: 418px;
    }
  }

  .cont-title {
    margin-top: 40px;
    width: 234px;
    height: 32px;
    border-radius: 4px;
  }

  .text01,
  .text02 {
    border-radius: 4px;
  }

  .box-prd {
    ${mixin.flex({ direction: 'column', align: 'flex-start' })};
    margin: 16px -20px 0 -20px;
    row-gap: 24px;
    overflow: auto hidden;
    overscroll-behavior: contain auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .list {
      ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
      padding: 0 20px;
      column-gap: 6px;

      .item {
        .thum {
          width: 136px;
          height: 181px;
          border-radius: 4px;
        }
        .text01 {
          margin-top: 8px;
          width: 120px;
          height: 20px;
        }
        .text02 {
          margin-top: 4px;
          width: 80px;
          height: 20px;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 20 200 20')};

    .box-top {
      margin: ${mixin.pxToVw('0 -20')};

      .main-banner {
        height: ${mixin.pxToVw('418')};
      }
    }

    .cont-title {
      margin-top: ${mixin.pxToVw('40')};
      width: ${mixin.pxToVw('234')};
      height: ${mixin.pxToVw('32')};
      border-radius: ${mixin.pxToVw('4')};
    }

    .text01,
    .text02 {
      border-radius: ${mixin.pxToVw('4')};
    }

    .box-prd {
      margin-top: ${mixin.pxToVw('16')};
      row-gap: ${mixin.pxToVw('24')};

      .list {
        column-gap: ${mixin.pxToVw('6')};

        .item {
          .thum {
            width: ${mixin.pxToVw('136')};
            height: ${mixin.pxToVw('181')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text01 {
            margin-top: ${mixin.pxToVw('8')};
            width: ${mixin.pxToVw('120')};
            height: ${mixin.pxToVw('20')};
          }

          .text02 {
            margin-top: ${mixin.pxToVw('4')};
            width: ${mixin.pxToVw('80')};
            height: ${mixin.pxToVw('20')};
          }
        }
      }
    }
  }
`;
